import { Launch } from "@models/launch.model.ts";
import { BaseSerializer } from "./baseSerializer.ts";

export class LaunchSerializer extends BaseSerializer {
  public deserialize(data: any): Launch {
    const gp = new Launch();
    this._copyLayersAttributes(gp, data);
    return gp;
  }
}
